/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum WorkPackageDependencyType {
  Ss = 'ss',
  Sf = 'sf',
  Fs = 'fs',
  Ff = 'ff'
}
